import { z } from "zod";

import { EMAIL_DELIVERY_ISSUES } from "@/constants/email-analytics";

export const emailDeliveryIssueSchema = z.nativeEnum(EMAIL_DELIVERY_ISSUES);

export const emailCountsSchema = z.object({
  sent: z.number(),
  delivered: z.number(),
  uniqueOpens: z.number(),
  uniqueClicks: z.number(),
  hardBounces: z.number(),
  softBounces: z.number(),
  spamReports: z.number(),
  openRate: z.number().nullable(),
  clickRate: z.number().nullable(),
  deliveryRate: z.number().nullable(),
  bounceRate: z.number().nullable(),
});

export const emailTypeOverviewSchema = emailCountsSchema.extend({
  emailType: z.string(),
});

export const emailOverviewTotalsSchema = emailCountsSchema;

export const emailOverviewResponseSchema = z.object({
  data: z.array(emailTypeOverviewSchema),
  totals: emailOverviewTotalsSchema,
});

export const emailTrendPointSchema = emailCountsSchema.extend({
  periodStart: z.string(),
});

export const emailDeliveryIssueRowSchema = z.object({
  id: z.number(),
  emailType: z.string().nullable(),
  issue: emailDeliveryIssueSchema,
  occurredAt: z.string(),
  sentAt: z.string().nullable(),
  patient: z.object({
    id: z.number().nullable(),
    name: z.string().nullable(),
    email: z.string().nullable(),
  }),
});
